module.exports = __webpack_public_path__ + "img/Z81_10.0bbeffbf.jpg";